export enum RaspScreenOrientation {
  LANDSCAPE = 'Landscape',
  LANDSCAPE_INVERSE = 'Landscape_inverse',
  PORTRAIT = 'Portrait',
  PORTRAIT_INVERSE = 'Portrait_inverse'
}
